// color = ring color that identifies the type. All coins are gold.
export const COINS = {
  INTJ: { metal:'Obsidian',  rarity:'Ultra Rare', color:'#6D28D9', symbol:'⬡', motto:'COGITO ERGO SUM',   year:'MMXXV' },
  INTP: { metal:'Platinum',  rarity:'Rare',        color:'#4F46E5', symbol:'∞', motto:'VERITAS ET LUX',    year:'MMXXV' },
  ENTJ: { metal:'Gold',      rarity:'Rare',        color:'#B45309', symbol:'⚜', motto:'VINCERE EST VIVERE', year:'MMXXV' },
  ENTP: { metal:'Electrum',  rarity:'Uncommon',    color:'#0369A1', symbol:'⚡', motto:'AUDAX ET CALLIDUS',  year:'MMXXV' },
  INFJ: { metal:'Gold',      rarity:'Ultra Rare',  color:'#7C3AED', symbol:'✦', motto:'ANIMA MUNDI',        year:'MMXXV' },
  INFP: { metal:'Rose Gold', rarity:'Uncommon',    color:'#BE185D', symbol:'◈', motto:'SOMNIUM VERUM',      year:'MMXXV' },
  ENFJ: { metal:'Gold',      rarity:'Uncommon',    color:'#C2410C', symbol:'☀', motto:'LUMEN ET VIA',       year:'MMXXV' },
  ENFP: { metal:'Copper',    rarity:'Common',      color:'#D97706', symbol:'✿', motto:'CARPE DIEM',         year:'MMXXV' },
  ISTJ: { metal:'Silver',    rarity:'Common',      color:'#475569', symbol:'⬛', motto:'SEMPER FIDELIS',     year:'MMXXV' },
  ISFJ: { metal:'Bronze',    rarity:'Common',      color:'#92400E', symbol:'♡', motto:'AMOR ET CURA',       year:'MMXXV' },
  ESTJ: { metal:'Silver',    rarity:'Common',      color:'#1D4ED8', symbol:'⚖', motto:'LEX ET ORDO',        year:'MMXXV' },
  ESFJ: { metal:'Copper',    rarity:'Common',      color:'#9D174D', symbol:'❋', motto:'COMMUNITAS',          year:'MMXXV' },
  ISTP: { metal:'Steel',     rarity:'Uncommon',    color:'#0F766E', symbol:'◆', motto:'VIS ET RATIO',        year:'MMXXV' },
  ISFP: { metal:'Bronze',    rarity:'Uncommon',    color:'#065F46', symbol:'❀', motto:'NATURA ET AMOR',      year:'MMXXV' },
  ESTP: { metal:'Brass',     rarity:'Uncommon',    color:'#991B1B', symbol:'⬟', motto:'AUDACES FORTUNA',     year:'MMXXV' },
  ESFP: { metal:'Copper',    rarity:'Common',      color:'#6B21A8', symbol:'✺', motto:'VITA GAUDENS',        year:'MMXXV' },
};

export const TYPES = {
  INTJ: {
    code:'INTJ', coin:COINS.INTJ, name:'The Architect', pct:'2%',
    tagline:'Strategic · Independent · Visionary',
    desc:"You see the world as a system of interconnected parts, and you quietly architect the future while others are still reading the map. Rare and unstoppable.",
    strengths:['Strategic thinking','Self-discipline','Independence','Determination'],
    challenges:['Emotional openness','Impatience','Perfectionism'],
    famous:'Elon Musk, Nietzsche, Schwarzenegger',
    hook:"Your coin is Obsidian — the hardest, rarest, most unbreakable.",
  },
  INTP: {
    code:'INTP', coin:COINS.INTP, name:'The Thinker', pct:'3%',
    tagline:'Analytical · Curious · Precise',
    desc:"Your mind never truly stops. You seek the right questions more than the right answers, and your logic cuts through noise like a platinum edge.",
    strengths:['Logic','Creativity','Objectivity','Thirst for knowledge'],
    challenges:['Procrastination','Social cues','Decision-making'],
    famous:'Einstein, Darwin, Bill Gates',
    hook:"Your coin is Platinum — cold, precise, and more valuable than gold.",
  },
  ENTJ: {
    code:'ENTJ', coin:COINS.ENTJ, name:'The Commander', pct:'3%',
    tagline:'Leader · Direct · Ambitious',
    desc:"You see a task and immediately know how to conquer it. The gold standard of leadership — powerful, decisive, unstoppable.",
    strengths:['Leadership','Efficiency','Confidence','Determination'],
    challenges:['Empathy','Patience','Listening'],
    famous:'Steve Jobs, Margaret Thatcher, Gordon Ramsay',
    hook:"Your coin is Gold — the universal symbol of power and achievement.",
  },
  ENTP: {
    code:'ENTP', coin:COINS.ENTP, name:'The Inventor', pct:'3%',
    tagline:'Innovative · Provocative · Brilliant',
    desc:"Rules are suggestions. You find the best solution where others give up, sparked by a mind that runs on pure electric curiosity.",
    strengths:['Innovation','Debate','Adaptability','Charisma'],
    challenges:['Focus','Routine','Finishing projects'],
    famous:'Da Vinci, Franklin, Obama',
    hook:"Your coin is Electrum — an ancient alloy prized for its lightning-like shine.",
  },
  INFJ: {
    code:'INFJ', coin:COINS.INFJ, name:'The Visionary', pct:'1%',
    tagline:'Intuitive · Deep · Rare',
    desc:"You sense what others feel before they say it. The rarest type in the world — your coin reflects that once-in-a-generation depth.",
    strengths:['Empathy','Intuition','Creativity','Vision'],
    challenges:['Hypersensitivity','Perfectionism','Burnout'],
    famous:'Martin Luther King, Mandela, Lady Gaga',
    hook:"Your coin is Gold — ancient, mystical, struck only 1% of the time.",
  },
  INFP: {
    code:'INFP', coin:COINS.INFP, name:'The Dreamer', pct:'4%',
    tagline:'Creative · Empathetic · Authentic',
    desc:"You live by your inner values and compromise them for no one. Your inner world is richer than most people's entire outer reality.",
    strengths:['Empathy','Creativity','Authenticity','Passion'],
    challenges:['Self-criticism','Setting limits','Pragmatism'],
    famous:'Tolkien, Johnny Depp, Audrey Hepburn',
    hook:"Your coin is Rose Gold — warm, rare, and unlike anything else.",
  },
  ENFJ: {
    code:'ENFJ', coin:COINS.ENFJ, name:'The Guide', pct:'2%',
    tagline:'Inspiring · Charismatic · Caring',
    desc:"People follow you not because they have to, but because you ignite something in them. You are the gold standard of human connection.",
    strengths:['Communication','Empathy','Leadership','Reliability'],
    challenges:['Over-commitment','Personal needs','Criticism'],
    famous:'Obama, Oprah Winfrey, Goethe',
    hook:"Your coin is Gold — warm, radiant, the coin everyone wants to hold.",
  },
  ENFP: {
    code:'ENFP', coin:COINS.ENFP, name:'The Explorer', pct:'7%',
    tagline:'Enthusiastic · Creative · Free',
    desc:"You see possibilities everywhere others see dead ends. Your energy is contagious, your ideas boundless, your spirit untameable.",
    strengths:['Enthusiasm','Creativity','Empathy','Communication'],
    challenges:['Focus','Over-commitment','Routine'],
    famous:'Robin Williams, Walt Disney, Anne Frank',
    hook:"Your coin is Copper — warm, energetic, the foundation of everything electric.",
  },
  ISTJ: {
    code:'ISTJ', coin:COINS.ISTJ, name:'The Guardian', pct:'13%',
    tagline:'Reliable · Methodical · Solid',
    desc:"You are the bedrock everything is built on. Silent and unbreakable — ISTJs keep the world running with quiet, relentless precision.",
    strengths:['Reliability','Rigor','Integrity','Practicality'],
    challenges:['Flexibility','New ideas','Emotional expression'],
    famous:'Angela Merkel, Warren Buffett, Freud',
    hook:"Your coin is Silver — timeless, steady, the backbone of every economy.",
  },
  ISFJ: {
    code:'ISFJ', coin:COINS.ISFJ, name:'The Protector', pct:'13%',
    tagline:'Caring · Loyal · Constant',
    desc:"You remember every birthday, every struggle, every quiet moment that mattered. You are the warm, unshakeable center of every circle.",
    strengths:['Care','Patience','Attention to detail','Loyalty'],
    challenges:['Setting limits','Change','Personal needs'],
    famous:'Mother Teresa, Kate Middleton, Halle Berry',
    hook:"Your coin is Bronze — ancient, warm, and built to last forever.",
  },
  ESTJ: {
    code:'ESTJ', coin:COINS.ESTJ, name:'The Director', pct:'11%',
    tagline:'Organized · Direct · Responsible',
    desc:"Chaos is your enemy. You know exactly how things should work — and you make it happen with precision, authority, and zero tolerance for inefficiency.",
    strengths:['Organization','Leadership','Reliability','Directness'],
    challenges:['Flexibility','Others emotions','Compromise'],
    famous:'Hillary Clinton, Frank Sinatra, Sheryl Sandberg',
    hook:"Your coin is Silver — authoritative, clear, built for governance.",
  },
  ESFJ: {
    code:'ESFJ', coin:COINS.ESFJ, name:'The Ambassador', pct:'12%',
    tagline:'Warm · Social · Caring',
    desc:"Your home is always open, your heart even more so. You are the glue that holds communities together — warm, loyal, indispensable.",
    strengths:['Social skills','Care','Reliability','Loyalty'],
    challenges:['Criticism','Boundaries','Independence'],
    famous:'Taylor Swift, Bill Clinton, Jennifer Garner',
    hook:"Your coin is Copper — warm, welcoming, the metal of human connection.",
  },
  ISTP: {
    code:'ISTP', coin:COINS.ISTP, name:'The Craftsman', pct:'5%',
    tagline:'Pragmatic · Calm · Precise',
    desc:"You understand how things work by taking them apart. Calm under pressure, precise in action — you are the master of any moment.",
    strengths:['Problem-solving','Calm under pressure','Practical thinking','Flexibility'],
    challenges:['Long-term commitment','Emotions','Structure'],
    famous:'Clint Eastwood, Bear Grylls, Scarlett Johansson',
    hook:"Your coin is Steel — engineered, precise, forged under extreme pressure.",
  },
  ISFP: {
    code:'ISFP', coin:COINS.ISFP, name:'The Artist', pct:'8%',
    tagline:'Sensitive · Creative · Gentle',
    desc:"You live in the present and see beauty where others don't look. Your inner compass is perfectly tuned to authenticity above all else.",
    strengths:['Aesthetic sense','Empathy','Adaptability','Authenticity'],
    challenges:['Future planning','Confrontation','Self-confidence'],
    famous:'Michael Jackson, Bob Dylan, Frida Kahlo',
    hook:"Your coin is Bronze — natural, warm, shaped by an artist's hand.",
  },
  ESTP: {
    code:'ESTP', coin:COINS.ESTP, name:'The Maverick', pct:'4%',
    tagline:'Energetic · Bold · Direct',
    desc:"You don't think about it — you act. ESTPs live in the moment with an intensity that fascinates everyone around them.",
    strengths:['Risk-taking','Energy','Directness','Crisis management'],
    challenges:['Long-term planning','Sensitivity','Rules'],
    famous:'Hemingway, Madonna, Mike Tyson',
    hook:"Your coin is Brass — bold, loud, and impossible to ignore.",
  },
  ESFP: {
    code:'ESFP', coin:COINS.ESFP, name:'The Performer', pct:'8%',
    tagline:'Spontaneous · Expressive · Joyful',
    desc:"Life is a stage and you love every second of it. Your energy is contagious, your joy is a gift, every room gets better when you walk in.",
    strengths:['Spontaneity','Energy','Enthusiasm','Generosity'],
    challenges:['Planning','Seriousness','Long-term focus'],
    famous:'Adele, Jamie Oliver, Marilyn Monroe',
    hook:"Your coin is Copper — vibrant, electric, the life of every circuit.",
  },
};

export const QUESTIONS = [
  {id:1,  dim:'EI', text:"At a party, you prefer to...", a:"Talk to as many different people as possible", b:"Have deep conversations with one or two people"},
  {id:2,  dim:'EI', text:"After a long social day, you feel...", a:"Energized and ready for more", b:"Drained and needing alone time"},
  {id:3,  dim:'EI', text:"You make important decisions by...", a:"Talking them through with others", b:"Thinking them through alone"},
  {id:4,  dim:'EI', text:"In a group, you tend to be...", a:"The one who starts conversations", b:"The one who listens and observes"},
  {id:5,  dim:'EI', text:"Your ideal work environment is...", a:"A busy open office with people around", b:"A quiet place where you can focus"},
  {id:6,  dim:'SN', text:"You trust more in...", a:"Your concrete experience and senses", b:"Your intuition and gut feeling"},
  {id:7,  dim:'SN', text:"When learning something new, you prefer...", a:"Practical examples and hands-on experience", b:"Understanding the underlying theory first"},
  {id:8,  dim:'SN', text:"You are more drawn to...", a:"What is real and present right now", b:"Possibilities and what could be"},
  {id:9,  dim:'SN', text:"You tend to describe things with...", a:"Precise, factual details", b:"Metaphors and mental images"},
  {id:10, dim:'SN', text:"You prefer work that is...", a:"Routine with clear, measurable results", b:"Varied and creative"},
  {id:11, dim:'TF', text:"When giving someone critical feedback...", a:"You say the truth directly, even if it stings", b:"You soften it to protect their feelings first"},
  {id:12, dim:'TF', text:"A good decision is primarily...", a:"Logical and rational", b:"Aligned with your values and others' wellbeing"},
  {id:13, dim:'TF', text:"In a conflict, you first seek...", a:"The most fair and logical solution", b:"Harmony and mutual understanding"},
  {id:14, dim:'TF', text:"People more often see you as...", a:"Direct and objective", b:"Empathetic and warm"},
  {id:15, dim:'TF', text:"Facing a problem, you prioritize...", a:"Analyzing the facts", b:"The impact on the people involved"},
  {id:16, dim:'JP', text:"You prefer to...", a:"Have a clear plan and stick to it", b:"Stay flexible and adapt as things unfold"},
  {id:17, dim:'JP', text:"Your workspace is usually...", a:"Organized and tidy", b:"A bit chaotic but you know where everything is"},
  {id:18, dim:'JP', text:"When facing deadlines, you...", a:"Finish well ahead of time", b:"Work best under last-minute pressure"},
  {id:19, dim:'JP', text:"You prefer projects that...", a:"Have a clear structure from the start", b:"Evolve freely as you go"},
  {id:20, dim:'JP', text:"A perfect weekend is...", a:"Planned in advance", b:"Spontaneous, seeing what comes up"},
  {id:21, dim:'EI', text:"You prefer to communicate...", a:"By talking it out", b:"In writing"},
  {id:22, dim:'SN', text:"You more easily notice...", a:"Practical details in your environment", b:"Patterns and connections between ideas"},
  {id:23, dim:'TF', text:"You feel prouder of...", a:"Your objective reasoning", b:"Your ability to understand others"},
  {id:24, dim:'JP', text:"When starting a project, you...", a:"Build a detailed plan first", b:"Jump in and see where it leads"},
  {id:25, dim:'EI', text:"After a great movie, you...", a:"Want to talk about it immediately", b:"Prefer to reflect on it alone first"},
  {id:26, dim:'AT', text:"When something goes wrong...", a:"I assess quickly and move on — it's fine", b:"I replay it for a long time and second-guess myself"},
  {id:27, dim:'AT', text:"Receiving criticism...", a:"I take what's useful and move on", b:"It stays with me longer than I'd like"},
  {id:28, dim:'AT', text:"When I miss a goal...", a:"I accept it and set new ones", b:"It pushes me to do better next time"},
  {id:29, dim:'AT', text:"My general stress level is...", a:"Usually calm and balanced", b:"Often self-pressured and demanding"},
  {id:30, dim:'AT', text:"My confidence in my decisions is...", a:"Solid — once I decide, I commit", b:"I often second-guess myself afterward"},
];

export function calculateType(answers) {
  const s={E:0,I:0,S:0,N:0,T:0,F:0,J:0,P:0};
  answers.forEach(({dim,choice})=>{
    if(dim==='EI'){if(choice==='a')s.E++;else s.I++;}
    if(dim==='SN'){if(choice==='a')s.S++;else s.N++;}
    if(dim==='TF'){if(choice==='a')s.T++;else s.F++;}
    if(dim==='JP'){if(choice==='a')s.J++;else s.P++;}
  });
  return (s.E>=s.I?'E':'I')+(s.S>=s.N?'S':'N')+(s.T>=s.F?'T':'F')+(s.J>=s.P?'J':'P');
}

export function calculateAT(atAnswers) {
  let a=0,b=0;
  atAnswers.forEach(({choice})=>{if(choice==='a')a++;else b++;});
  return a>=b?'A':'T';
}
